import classNames from "classnames";
import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { FAQContent } from "../../../../domain/faq/FAQContent";
import { FAQTitle } from "../../../../domain/faq/FAQTitle";
import { useBoolean } from "../../../hooks/common/useBoolean";
import { useInput } from "../../../hooks/common/useInput";
import { AddLinkButton } from "../../common/button/AddLinkButton";
import { Button } from "../../common/button/Button";
import { CancelCircleButton } from "../../common/button/CancelCircleButton";
import { InputTextArea } from "../../common/input/InputTexArea";
import { InputTextBox } from "../../common/input/InputTextBox";
import md from "./MarkdownParser";

export function FAQInput(props: FAQInputProps) {

    const { initialTitle, initialContent, handleButtonClicked, buttonLabel } = props;

    const [title, , handleTitleChanged] = useInput(initialTitle);

    const [titleError, setTitleError] = useState("");

    const [content, setContent, handleContentChanged] = useInput(initialContent);

    const [contentError, setContentError] = useState("");

    const [url, setUrl, handleUrlChanged] = useInput("");

    const [displayString, setDisplayString, handleDisplayString] = useInput("");

    const handleButtonClickedWrapper = () => {

        const faqTitleError = FAQTitle.isInvalidSize(title) ? FAQTitle.messageInvalidSize("タイトル") : "";

        setTitleError(faqTitleError);

        const faqContentError = FAQContent.isInvalidSize(content) ? FAQContent.messageInvalidSize("内容") : "";

        setContentError(faqContentError);

        if (faqTitleError || faqContentError) return;

        handleButtonClicked(title, content);
    };


    const [openLinkDialog, , close, toggle] = useBoolean();

    const onEnterAtLinkDialog = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            setContent((previous) => previous + `[${displayString}](${url})`);
            close();
            handleUrlChanged("");
            handleDisplayString("");
        }
    };

    return (
        <div className={"faq_edit"}>
            <div className={"content"}>
                {/* FAQの「Q」の方 */}
                <div className={"body"}>
                    <div className="label">
                        <div className="label_name">タイトル</div>
                        <div className="error_message">{titleError}</div>
                    </div>
                    <InputTextBox value={title} handleTextChanged={handleTitleChanged} />
                </div>
                {/* FAQの「A」の方 */}
                <div className={"body"}>
                    <div className="label">
                        <div className="label_and_button">
                            <div className="label_name">内容</div>
                            <div className="link_button_area">
                                <AddLinkButton onClick={toggle} />
                                <AddLinkDialog openLinkDialog={openLinkDialog} url={url} displayString={displayString}
                                    setUrl={setUrl}
                                    setDisplayUrl={setDisplayString}
                                    close={close}
                                    onEnterAtLinkDialog={onEnterAtLinkDialog}
                                />
                            </div>
                        </div>
                        <div className="error_message">{contentError}</div>
                    </div>
                    <div className="edit_area">
                        <div className="editor">
                            <InputTextArea value={content} handleTextChanged={handleContentChanged} />
                        </div>
                        {/* eslint-disable-next-line */} {/* '__html'というプロパティ名がeslintルールに引っかかるためeslintをdisabledにする */}
                        {content.length > 0 ? <div className="preview" dangerouslySetInnerHTML={{ __html: md.render(content) }} />
                            : <div className="preview__empty">プレビューが表示されます</div>}
                    </div>
                </div>
            </div>
            <Button label={buttonLabel} onClick={handleButtonClickedWrapper} />
        </div>
    );
}

const AddLinkDialog = (props: {
    openLinkDialog: boolean,
    url: string,
    displayString: string,
    setUrl: (value: string) => void,
    setDisplayUrl: (value: string) => void,
    close: () => void,
    onEnterAtLinkDialog: (e: React.KeyboardEvent<HTMLInputElement>) => void
}) => {
    const { openLinkDialog, url, displayString, setUrl, setDisplayUrl, close, onEnterAtLinkDialog } = props;
    return (
        <OutsideClickHandler onOutsideClick={close}>
            <div className={classNames("add_link_dialog", { active: openLinkDialog })} >
                <input type="text" placeholder="リンクを入力" value={url} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setUrl(e.target.value)} />
                <input type="text" placeholder="表示する文字を入力" value={displayString} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setDisplayUrl(e.target.value)} onKeyPress={onEnterAtLinkDialog} />
                <div className="cancel_button_area">
                    <CancelCircleButton onClick={close} />
                </div>
            </div>
        </OutsideClickHandler>
    );
};

type FAQInputProps = {
    initialTitle: string,
    initialContent: string
    handleButtonClicked: (title: string, content: string) => void
    buttonLabel: string
}